const state = {
    measure:{
        maxLength:1000,
        overrideMessage: '' //this.$t('kpi.maxLength')
    },
    locale: 'es'
    // Removido sector e sectors - agora usamos getters que referenciam current.js
}

const mutations = {
    setLocale(state, locale){
        state.locale = locale;
        localStorage.setItem('locale', locale);
        document.documentElement.setAttribute('lang', locale);
    },
    // Mutation mantida por compatibilidade - não faz nada pois sector vem de current.js via getter
    setSector(state, sector){
        // Setor agora é gerenciado pelo store current.js
        // Esta mutation existe apenas para compatibilidade com código legado
    }
}

const getters = {
    getMeasureMaxLength(base){
        return base.measure.maxLength;
    },
    getMeasureOverrideMessage(base){
        return base.measure.overrideMessage;
    },
    // Getters que referenciam current.js (Single Source of Truth)
    sector: (state, getters, rootState) => rootState.current.sector,
    sectors: (state, getters, rootState) => rootState.current.sectors
}
export default {
    namespaced: true,
    state,
    mutations,
    getters
}